import { useEffect } from 'react';
import {
    disableRightClick,
    disableImageDrag,
    disableKeyboardShortcuts,
    disableTextSelection,
    addImageOverlay,
} from '../utils/contentProtection';

const defaultConfig = {
    disableRightClick: true,
    disableImageDrag: true,
    disableKeyboardShortcuts: true,
    disableTextSelection: false,
    addImageOverlay: true,
};

const useContentProtection = (config = {}) => {
    const {
        disableRightClick: disableRightClickEnabled,
        disableImageDrag: disableImageDragEnabled,
        disableKeyboardShortcuts: disableKeyboardShortcutsEnabled,
        disableTextSelection: disableTextSelectionEnabled,
        addImageOverlay: addImageOverlayEnabled,
    } = { ...defaultConfig, ...config };

    useEffect(() => {
        const cleanups = [];

        if (disableRightClickEnabled) {
            cleanups.push(disableRightClick());
        }

        if (disableImageDragEnabled) {
            cleanups.push(disableImageDrag());
        }

        if (disableKeyboardShortcutsEnabled) {
            cleanups.push(disableKeyboardShortcuts());
        }

        if (disableTextSelectionEnabled) {
            cleanups.push(disableTextSelection());
        }

        if (addImageOverlayEnabled) {
            cleanups.push(addImageOverlay());
        }

        return () => {
            cleanups.forEach((cleanup) => {
                if (typeof cleanup === 'function') {
                    cleanup();
                }
            });
        };
    }, [disableRightClickEnabled, disableImageDragEnabled, disableKeyboardShortcutsEnabled, disableTextSelectionEnabled, addImageOverlayEnabled]);
};

export default useContentProtection;
